const mapMod = [
  {
    "no": 1,
    "mod": "몬스터에게 걸리는 저주 효과 #% 감폭",
    "engMod": "#% less effect of Curses on Monsters",
    "regex": "주.*폭",
    "engRegex": "rses",
    "lv": 1
  },
  {
    "no": 2,
    "mod": "서로 가까이 있는 적을 처치하면 이계 몬스터를 불러옴",
    "engMod": "Slaying Enemies close together has a #% chance to attract monsters from Beyond",
    "regex": "이계",
    "engRegex": "yi",
    "lv": 1
  },
  {
    "no": 3,
    "mod": "몬스터의 생명력 (25-30)% 증폭\n몬스터 기절 면역",
    "engMod": "(25-30)% more Monster Life Monsters cannot be Stunned",
    "regex": "기절",
    "engRegex": "tun",
    "lv": 1
  },
  {
    "no": 4,
    "mod": "몬스터가 물리 피해의 18%를 반사",
    "engMod": "Monsters reflect #% of Physical Damage",
    "regex": "물.*반",
    "engRegex": "f ph",
    "lv": 1
  },
  {
    "no": 5,
    "mod": "몬스터가 원소 피해의 18%를 반사",
    "engMod": "Monsters reflect #% of Elemental Damage",
    "regex": "원.*반",
    "engRegex": "tal d",
    "lv": 1
  },
  {
    "no": 6,
    "mod": "몬스터 도발 면역\n몬스터의 동작 속도가 기본 수치 밑으로 내려가지 않음",
    "engMod": "Monsters' Action Speed cannot be modified to below base value Monsters cannot be Taunted",
    "regex": "도발",
    "engRegex": "elo",
    "lv": 1
  },
  {
    "no": 7,
    "mod": "몬스터가 50%의 확률로 중독, 꿰뚫기, 출혈 회피",
    "engMod": "Monsters have a #% chance to avoid Poison, Impale, and Bleeding",
    "regex": "출혈",
    "engRegex": "on,",
    "lv": 1
  },
  {
    "no": 8,
    "mod": "몬스터의 주문 피해 억제 확률 +60%",
    "engMod": "Monsters have +#% chance to Suppress Spell Damage",
    "regex": "제.확",
    "engRegex": "o su",
    "lv": 1
  },
  {
    "no": 9,
    "mod": "몬스터의 물리 피해 감소 +40%",
    "engMod": "+#% Monster Physical Damage Reduction",
    "regex": "해.감",
    "engRegex": "uct",
    "lv": 2
  },
  {
    "no": 10,
    "mod": "몬스터의 생명력 (40-49)% 증폭",
    "engMod": "#% more Monster Life",
    "regex": "력.*증폭",
    "engRegex": "r li",
    "lv": 2
  },
  {
    "no": 11,
    "mod": "몬스터가 (90-110)%의 추가 물리 피해를 화염 속성으로 가함",
    "engMod": "Monsters deal #% extra Physical Damage as Fire",
    "regex": "염.속",
    "engRegex": "as fi",
    "lv": 2
  },
  {
    "no": 12,
    "mod": "몬스터가 (90-110)%의 추가 물리 피해를 냉기 속성으로 가함",
    "engMod": "Monsters deal #% extra Physical Damage as Cold",
    "regex": "기.속",
    "engRegex": "s col",
    "lv": 2
  },
  {
    "no": 13,
    "mod": "몬스터가 (90-110)%의 추가 물리 피해를 번개 속성으로 가함",
    "engMod": "Monsters deal #% extra Physical Damage as Lightning",
    "regex": "개.속",
    "engRegex": "as l",
    "lv": 2
  },
  {
    "no": 14,
    "mod": "몬스터가 물리 피해의 (31-35)%를 추가 카오스 피해로 획득\n몬스터가 명중 시 2초 동안 위축 유발",
    "engMod": "Monsters deal #% extra Physical Damage as Chaos Monsters Inflict Withered for 2 seconds on Hit",
    "regex": "축",
    "engRegex": "withe",
    "lv": 2
  },
  {
    "no": 15,
    "mod": "몬스터가 투사체 2개 추가 발사",
    "engMod": "Monsters fire 2 additional Projectiles",
    "regex": "투.추",
    "engRegex": "l pr",
    "lv": 3
  },
  {
    "no": 16,
    "mod": "몬스터 피해 (22-25)% 증가",
    "engMod": "#% increased Monster Damage",
    "regex": "터.피.*증",
    "engRegex": "%.*r d",
    "lv": 3
  },
  {
    "no": 17,
    "mod": "몬스터의 이동 속도 (25-30)% 증가\n몬스터의 공격 속도 (35-45)% 증가",
    "engMod": "#% increased Monster Movement Speed #% increased Monster Attack Speed #% increased Monster Cast Speed",
    "regex": "동.속.*증",
    "engRegex": "r at",
    "lv": 3
  },
  {
    "no": 18,
    "mod": "고유 보스가 주는 피해 25% 증가\n고유 보스의 공격 및 시전 속도 30% 증가",
    "engMod": "Unique Boss deals #% increased Damage Unique Boss has #% increased Attack and Cast Speed",
    "regex": "격.및",
    "engRegex": "d at",
    "lv": 3
  },
  {
    "no": 19,
    "mod": "고유 보스의 생명력 35% 증가\n고유 보스의 효과 범위 70% 증가",
    "engMod": "Unique Boss has #% increased Life Unique Boss has #% increased Area of Effect",
    "regex": "고.*범",
    "engRegex": "d li",
    "lv": 3
  },
  {
    "no": 20,
    "mod": "몬스터가 명중 시 20%의 확률로 원소 상태 이상 유발",
    "engMod": "Monsters have a #% chance to cause Elemental Ailments on Hit",
    "regex": "상.유",
    "engRegex": "cau",
    "lv": 3
  },
  {
    "no": 21,
    "mod": "몬스터의 카오스 저항 +25%\n몬스터의 원소 저항 +40%",
    "engMod": "+#% Monster Chaos Resistance +#% Monster Elemental Resistances",
    "regex": "카.*항",
    "engRegex": "r el",
    "lv": 3
  },
  {
    "no": 22,
    "mod": "몬스터가 최대 생명력의 (40-49)%를 추가 에너지 보호막 최대치로 획득",
    "engMod": "Monsters gain #% of Maximum Life as Extra Maximum Energy Shield",
    "regex": "치로",
    "engRegex": "m li",
    "lv": 3
  },
  {
    "no": 23,
    "mod": "몬스터의 스킬 2회 추가 연쇄",
    "engMod": "Monsters' skills Chain 2 additional times",
    "regex": "가.연",
    "engRegex": "l tim",
    "lv": 4
  },
  {
    "no": 24,
    "mod": "몬스터가 사술 방지 보유",
    "engMod": "Monsters are Hexproof",
    "regex": "사술",
    "engRegex": "re he",
    "lv": 4
  },
  {
    "no": 25,
    "mod": "지역에 고유 보스 2마리 등장",
    "engMod": "Area contains two Unique Bosses",
    "regex": "2마",
    "engRegex": "two",
    "lv": 4
  },
  {
    "no": 26,
    "mod": "모든 몬스터의 적중 피해가 항상 점화 유발",
    "engMod": "All Monster Damage from Hits always Ignites",
    "regex": "항상",
    "engRegex": "lw",
    "lv": 4
  },
  {
    "no": 27,
    "mod": "몬스터가 공격 시 60%의 확률로 꿰뚫음",
    "engMod": "Monsters have #% chance to Impale with Attacks",
    "regex": "뚫음",
    "engRegex": "o im",
    "lv": 4
  },
  {
    "no": 28,
    "mod": "고유 보스가 사로잡힘",
    "engMod": "Unique Bosses are Possessed",
    "regex": "사로",
    "engRegex": "poss",
    "lv": 4
  },
  {
    "no": 29,
    "mod": "지역에 다수의 토템 존재",
    "engMod": "Area contains many Totems",
    "regex": "토.*존",
    "engRegex": "tot",
    "lv": 5
  },
  {
    "no": 30,
    "mod": "희귀 몬스터 수 (20-30)% 증가",
    "engMod": "#% increased number of Rare Monsters",
    "regex": "귀.*증",
    "engRegex": "d nu",
    "lv": 5
  },
  {
    "no": 31,
    "mod": "지역에 탈주 유배자 추가 2명이 서식",
    "engMod": "Area is inhabited by 2 additional Rogue Exiles",
    "regex": "유배",
    "engRegex": "rog",
    "lv": 5
  },
  {
    "no": 32,
    "mod": "지역에 해골 서식",
    "engMod": "Area is inhabited by Skeletons",
    "regex": "해골",
    "engRegex": "eto",
    "lv": 5
  },
  {
    "no": 33,
    "mod": "지역에 염소인간 서식",
    "engMod": "Area is inhabited by Goatmen",
    "regex": "소인",
    "engRegex": "oa",
    "lv": 5
  },
  {
    "no": 34,
    "mod": "지역에 바다 마녀 및 유충 서식",
    "engMod": "Area is inhabited by Sea Witches and their Spawn",
    "regex": "녀",
    "engRegex": "ei",
    "lv": 5
  },
  {
    "no": 35,
    "mod": "지역에 언데드 서식",
    "engMod": "Area is inhabited by Undead",
    "regex": "언",
    "engRegex": "ead",
    "lv": 5
  },
  {
    "no": 36,
    "mod": "지역에 원거리형 몬스터 서식",
    "engMod": "Area is inhabited by ranged monsters",
    "regex": "리형",
    "engRegex": "ang",
    "lv": 5
  },
  {
    "no": 37,
    "mod": "지역에 동물 서식",
    "engMod": "Area is inhabited by Animals",
    "regex": "동물",
    "engRegex": "nim",
    "lv": 5
  },
  {
    "no": 38,
    "mod": "지역에 악마 서식",
    "engMod": "Area is inhabited by Demons",
    "regex": "악",
    "engRegex": "emo",
    "lv": 5
  },
  {
    "no": 39,
    "mod": "지역에 인간형 적 서식",
    "engMod": "Area is inhabited by Humanoids",
    "regex": "간형",
    "engRegex": "hum",
    "lv": 5
  },
  {
    "no": 40,
    "mod": "지역에 솔라리스 광신도 거주",
    "engMod": "Area is inhabited by Solaris fanatics",
    "regex": "솔",
    "engRegex": "lar",
    "lv": 5
  },
  {
    "no": 41,
    "mod": "지역에 루나리스 광신도 거주",
    "engMod": "Area is inhabited by Lunaris fanatics",
    "regex": "루",
    "engRegex": "una",
    "lv": 5
  },
  {
    "no": 42,
    "mod": "지역에 혼 서식",
    "engMod": "Area is inhabited by Ghosts",
    "regex": "혼.서",
    "engRegex": "ost",
    "lv": 5
  },
  {
    "no": 43,
    "mod": "지역에 키타바 광신자 거주",
    "engMod": "Area is inhabited by Cultists of Kitava",
    "regex": "키타",
    "engRegex": "cul",
    "lv": 5
  },
  {
    "no": 44,
    "mod": "지역에 등장하는 몬스터 종류 증가",
    "engMod": "Area has increased monster variety",
    "regex": "종류",
    "engRegex": "ety",
    "lv": 5
  },
  {
    "no": 45,
    "mod": "지역에 흉물 서식",
    "engMod": "Area is inhabited by Abominations",
    "regex": "에.흉",
    "engRegex": "bom",
    "lv": 5
  },
  {
    "no": 46,
    "mod": "몬스터의 스킬 3회 추가 연쇄\n몬스터의 투사체가 지형과 충돌 시 연쇄 가능",
    "engMod": "Monsters' skills Chain 3 additional times\nMonsters' Projectiles can Chain when colliding with Terrain",
    "regex": "충돌",
    "engRegex": "lid",
    "lv": 17
  },
  {
    "no": 47,
    "mod": "플레이어들과 그 소환수가 10초마다 3초 동안 피해를 주지 않음",
    "engMod": "Players and their Minions deal no damage for 3 out of every 10 seconds",
    "regex": "과.그",
    "engRegex": "ever",
    "lv": 17
  },
  {
    "no": 48,
    "mod": "몬스터의 효과 범위 100% 증가\n몬스터가 투사체 2개 추가 발사",
    "engMod": "Monsters have 100% increased Area of Effect\nMonsters fire 2 additional Projectiles",
    "regex": "가.발",
    "engRegex": "l pr",
    "lv": 17
  },
  {
    "no": 49,
    "mod": "몬스터 피해 (30-40)% 증가",
    "engMod": "(30-40)% increased Monster Damage",
    "regex": "터.피.*증",
    "engRegex": "d monster d",
    "lv": 17
  },
  {
    "no": 50,
    "mod": "몬스터가 최대 생명력의 (70-80)%를 추가 에너지 보호막 최대치로 획득",
    "engMod": "Monsters gain (70-80)% of Maximum Life as Extra Maximum Energy Shield",
    "regex": "치로",
    "engRegex": "m li",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 51,
    "mod": "고유 보스가 사로잡힘",
    "engMod": "Unique Bosses are Possessed",
    "regex": "사로",
    "engRegex": "poss",
    "lv": 17
  },
  {
    "no": 52,
    "mod": "몬스터의 주문 피해 억제 확률 +100%",
    "engMod": "Monsters have +100% chance to Suppress Spell Damage",
    "regex": "제.확",
    "engRegex": "o su",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 53,
    "mod": "몬스터의 공격 피해 막기 확률 +50%",
    "engMod": "Monsters have +50% Chance to Block Attack Damage",
    "regex": "공.*막",
    "engRegex": "k at",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 54,
    "mod": "몬스터가 물리 피해의 20%를 반사\n몬스터가 원소 피해의 20%를 반사",
    "engMod": "Monsters reflect 20% of Physical Damage\nMonsters reflect 20% of Elemental Damage",
    "regex": "몬.*반",
    "engRegex": "f ph",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 55,
    "mod": "몬스터의 생명력 (90-100)% 증폭",
    "engMod": "(90-100)% more Monster Life",
    "regex": "력.*증폭",
    "engRegex": "r li",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 56,
    "mod": "희귀 몬스터 수 (35-45)% 증가\n희귀 몬스터가 각각 속성 2개 추가 보유",
    "engMod": "(35-45)% increased number of Rare Monsters\nRare Monsters each have 1 additional Modifier",
    "regex": "각.속",
    "engRegex": "s ea",
    "lv": 17
  },
  {
    "no": 57,
    "mod": "몬스터가 명중 시 탐욕스러운 덩굴 2개 유발",
    "engMod": "Monsters inflict 2 Grasping Vines on Hit",
    "regex": "탐욕",
    "engRegex": "pin",
    "lv": 17,
    "opt": "지도 60%"
  },
  {
    "no": 58,
    "mod": "희귀 몬스터가 폭발성 중심부 보유",
    "engMod": "Rare Monsters have Volatile Cores",
    "regex": "성.중",
    "engRegex": "cores",
    "lv": 17,
    "opt": "갑충 78%"
  },
  {
    "no": 59,
    "mod": "몬스터가 물리 피해의 (180-200)%를 추가 무작위 원소 피해로 획득",
    "engMod": "Monsters gain (180-200)% of their Physical Damage as Extra Damage of a random Element",
    "regex": "무.*원",
    "engRegex": "om e",
    "lv": 17
  },
  {
    "no": 60,
    "mod": "몬스터가 물리 피해의 (80-100)%를 추가 카오스 피해로 획득",
    "engMod": "Monsters gain (80-100)% of their Physical Damage as Extra Chaos Damage",
    "regex": "카.*피",
    "engRegex": "ra c",
    "lv": 17
  },
  {
    "no": 61,
    "mod": "몬스터의 이동 속도 (25-30)% 증가\n몬스터의 공격 속도 (35-45)% 증가\n몬스터의 시전 속도 (35-45)% 증가",
    "engMod": "(25-30)% increased Monster Movement Speed\n(35-45)% increased Monster Attack Speed\n(35-45)% increased Monster Cast Speed",
    "regex": "동.속.*증",
    "engRegex": "r at",
    "lv": 17
  },
  {
    "no": 62,
    "mod": "플레이어들이 피얼룩 톱날에 습격당함",
    "engMod": "Players are assaulted by Bloodstained Sawblades",
    "regex": "톱",
    "engRegex": "wb",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 64,
    "mod": "지역에 질식의 구체 등장",
    "engMod": "Area contains Drowning Orbs",
    "regex": "질",
    "engRegex": "wni",
    "lv": 17
  },
  {
    "no": 65,
    "mod": "몬스터의 물리 피해 감소 +50%\n몬스터의 카오스 저항 +35%\n몬스터의 원소 저항 +55%",
    "engMod": " +50% Monster Physical Damage Reduction\n+35% Monster Chaos Resistance\n+55% Monster Elemental Resistances",
    "regex": "물.*감",
    "engRegex": "uct",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 66,
    "mod": "몬스터가 주는 모든 피해가 점화, 동결, 감전 유발 가능\n몬스터가 명중 시 점화, 동결, 감전 유발",
    "engMod": "All Monster Damage can Ignite, Freeze and Shock\nMonsters Ignite, Freeze and Shock on Hit",
    "regex": "시.점",
    "engRegex": "te,",
    "lv": 17,
    "opt": "갑충 90%"
  },
  {
    "no": 67,
    "mod": "플레이어들이 희귀 또는 고유 몬스터 처치 후\n10초 동안 죽음의 징표 획득",
    "engMod": "Players are Marked for Death for 10 seconds\nafter killing a Rare or Unique monster",
    "regex": "징",
    "engRegex": "rke",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 68,
    "mod": "희귀 및 고유 몬스터가 명중 시 생명력, 마나 및 에너지 보호막의 5% 제거",
    "engMod": "Rare and Unique Monsters remove 5% of Life, Mana and Energy Shield on hit",
    "regex": "%.제",
    "engRegex": "na a",
    "lv": 17,
    "opt": "화폐 126%"
  },
  {
    "no": 70,
    "mod": "몬스터의 공격이 명중 시 꿰뚫음\n플레이어에게 다섯 번째 꿰뚫기가 유발되면 꿰뚫기가 제거되고, 꿰뚫기의 물리 피해에 남은 명중 횟수를 곱한 만큼의 피해가 해당 플레이어 및 1.8미터 내의 동료들에게 반사됨",
    "engMod": "Monsters' Attacks Impale on Hit\nWhen a fifth Impale is inflicted on a Player, Impales are removed to Reflect thier Physical Damage multiplied by their remaining Hits to that Player and their Allies within 1.8 metres",
    "regex": "곱",
    "engRegex": "fif",
    "lv": 17,
    "opt": "화폐 84%"
  },
  {
    "no": 71,
    "mod": "지역 내 희귀 몬스터가 쉐이퍼의 손길에 닿음",
    "engMod": "Rare monsters in area are Shaper-Touched",
    "regex": "쉐",
    "engRegex": "hap",
    "lv": 17
  },
  {
    "no": 73,
    "mod": "플레이어의 지뢰 투척 스킬이 지뢰를 1개 덜 투척\n플레이어의 덫 투척 스킬이 덫을 1개 덜 투척",
    "engMod": "Player Skills which Throw Mines throw 1 fewer Mine\nPlayer Skills which Throw Traps throw 1 fewer Trap",
    "regex": "뢰",
    "engRegex": "hro",
    "lv": 17,
    "opt": "갑충 53%"
  },
  {
    "no": 74,
    "mod": "플레이어들의 토템이 피격 시 받는 피해의 15%를 소환자의 생명력에 대신 적용",
    "engMod": "15% of Damage Players' Totems take from Hits is taken from their Summoner's Life instead",
    "regex": "대신",
    "engRegex": "oner",
    "lv": 17,
    "opt": "갑충 53%"
  },
  {
    "no": 76,
    "mod": "지도 보스가 결합 보스 대동",
    "engMod": "Map Boss is accompanied by a Synthesis Boss",
    "regex": "대동",
    "engRegex": "yn",
    "lv": 17
  },
  {
    "no": 77,
    "mod": "지역에 작열의 총주교의 룬 등장",
    "engMod": "Area contains Runes of the Searing Exarch",
    "regex": "룬",
    "engRegex": "rune",
    "lv": 17
  },
  {
    "no": 1,
    "mod": "플레이어의 생명력 및 에너지 보호막 회복 속도 #% 감폭",
    "engMod": "Players have #% less Recovery Rate of Life and Energy Shield",
    "regex": "및.*감",
    "engRegex": "s rec",
    "lv": 1
  },
  {
    "no": 2,
    "mod": "플레이어가 생명력, 마나 또는 에너지 보호막 재생 불가",
    "engMod": "Players cannot Regenerate Life, Mana or Energy Shield",
    "regex": "재생",
    "engRegex": "gen",
    "lv": 1
  },
  {
    "no": 3,
    "mod": "플레이어 저항 최대치 (-12--9)%",
    "engMod": "Players have -#% to all maximum Resistances",
    "regex": "항.최",
    "engRegex": "o al",
    "lv": 1
  },
  {
    "no": 4,
    "mod": "몬스터에게서 흡수할 수 없음",
    "engMod": "Cannot Leech from Monsters",
    "regex": "흡수",
    "engRegex": "eec",
    "lv": 1
  },
  {
    "no": 5,
    "mod": "몬스터가 70%의 확률로 원소 상태 이상 긴급회피",
    "engMod": "Monsters have #% chance to Avoid Elemental Ailments",
    "regex": "급회",
    "engRegex": "d el",
    "lv": 1
  },
  {
    "no": 7,
    "mod": "몬스터의 치명타 확률 (360-400)% 증가\n몬스터의 치명타 피해 배율 +(41-45)%",
    "engMod": "Monsters have #% increased Critical Strike Chance +#% to Monster Critical Strike Multiplier",
    "regex": "배율",
    "engRegex": "tip",
    "lv": 2
  },
  {
    "no": 8,
    "mod": "플레이어의 플라스크 충전량 50% 감소",
    "engMod": "Players gain #% reduced Flask Charges",
    "regex": "전량",
    "engRegex": "k c",
    "lv": 2
  },
  {
    "no": 10,
    "mod": "플레이어의 방어도 30% 감폭\n플레이어의 막기 확률 40% 감소",
    "engMod": "Players have #% reduced Chance to Block Players have #% less Armour",
    "regex": "어도",
    "engRegex": "arm",
    "lv": 2
  },
  {
    "no": 11,
    "mod": "몬스터가 명중 시 권능, 격분, 인내 충전 강탈",
    "engMod": "Monsters steal Power, Frenzy and Endurance charges on Hit",
    "regex": "강탈",
    "engRegex": "r,",
    "lv": 2
  },
  {
    "no": 12,
    "mod": "플레이어의 재사용 대기시간 회복 속도 40% 감폭",
    "engMod": "Players have #% less Cooldown Recovery Rate",
    "regex": "대기",
    "engRegex": "coo",
    "lv": 2
  },
  {
    "no": 13,
    "mod": "플레이어가 비-저주 오라 스킬로 받는 효과 60% 감소",
    "engMod": "Players have #% reduced effect of Non-Curse Auras from Skills",
    "regex": "오라",
    "engRegex": "non",
    "lv": 2
  },
  {
    "no": 14,
    "mod": "플레이어의 정확도 25% 감폭",
    "engMod": "Players have #% less Accuracy Rating",
    "regex": "플.*정",
    "engRegex": "ss ac",
    "lv": 2
  },
  {
    "no": 15,
    "mod": "몬스터의 효과 범위 100% 증가",
    "engMod": "Monsters have #% increased Area of Effect",
    "regex": "몬.*범",
    "engRegex": "m.*area",
    "lv": 3
  },
  {
    "no": 16,
    "mod": "플레이어가 원소 약화 저주에 걸림",
    "engMod": "Players are Cursed with Elemental Weakness",
    "regex": "소.약",
    "engRegex": "h el",
    "lv": 3
  },
  {
    "no": 17,
    "mod": "플레이어가 취약성 저주에 걸림",
    "engMod": "Players are Cursed with Vulnerability",
    "regex": "취약",
    "engRegex": "h vu",
    "lv": 3
  },
  {
    "no": 18,
    "mod": "플레이어가 쇠약화 저주에 걸림",
    "engMod": "Players are Cursed with Enfeeble",
    "regex": "쇠약",
    "engRegex": "h en",
    "lv": 3
  },
  {
    "no": 19,
    "mod": "플레이어가 시간의 사슬 저주에 걸림",
    "engMod": "Players are Cursed with Temporal Chains",
    "regex": "사슬",
    "engRegex": "h tem",
    "lv": 3
  },
  {
    "no": 20,
    "mod": "몬스터가 치명타로 받는 추가 피해 (36-40)% 감소",
    "engMod": "Monsters take #% reduced Extra Damage from Critical Strikes",
    "regex": "치.*감",
    "engRegex": "kes",
    "lv": 3
  },
  {
    "no": 21,
    "mod": "플레이어에게 적용되는 버프가 70% 더 빠르게 만료됨",
    "engMod": "Buffs on Players expire #% faster",
    "regex": "플..*버",
    "engRegex": "fs",
    "lv": 3
  },
  {
    "no": 22,
    "mod": "마법 몬스터 (20-30)% 증가",
    "engMod": "#% increased Magic Monsters",
    "regex": "법.몬",
    "engRegex": "d mag",
    "lv": 4
  },
  {
    "no": 23,
    "mod": "몬스터의 공격 명중 시 중독",
    "engMod": "Monsters Poison on Hit",
    "regex": "시.중",
    "engRegex": "son o",
    "lv": 4
  },
  {
    "no": 24,
    "mod": "플레이어가 노출 유발 불가",
    "engMod": "Players cannot inflict Exposure",
    "regex": "노출",
    "engRegex": "ot i",
    "lv": 4
  },
  {
    "no": 25,
    "mod": "몬스터의 정확도 50% 증가\n플레이어가 방지하는 억제된 주문 피해 -20%",
    "engMod": "Players have -#% to amount of Suppressed Spell Damage Prevented Monsters have #% increased Accuracy Rating",
    "regex": "몬.*정",
    "engRegex": "rev",
    "lv": 4
  },
  {
    "no": 27,
    "mod": "플레이어의 효과 범위 25% 감폭",
    "engMod": "Players have #% less Area of Effect",
    "regex": "플.*범",
    "engRegex": "ss are",
    "lv": 4
  },
  {
    "no": 28,
    "mod": "지역에 용암 지대 존재",
    "engMod": "Area has patches of Burning Ground",
    "regex": "암.지",
    "engRegex": "urn",
    "lv": 5
  },
  {
    "no": 29,
    "mod": "지역에 얼음 지대 존재",
    "engMod": "Area has patches of Chilled Ground",
    "regex": "얼음",
    "engRegex": "hil",
    "lv": 5
  },
  {
    "no": 30,
    "mod": "지역에 #%만큼 피해가 증가한 감전 지대 존재",
    "engMod": "Area has patches of Shocked Ground which increase Damage taken by #%",
    "regex": "감.*대",
    "engRegex": "cke",
    "lv": 5
  },
  {
    "no": 31,
    "mod": "지역에 훼손된 지대 존재",
    "engMod": "Area has patches of desecrated ground",
    "regex": "훼손",
    "engRegex": "des",
    "lv": 5
  },
  {
    "no": 32,
    "mod": "지역에 신성화 지대 존재",
    "engMod": "Area has patches of Consecrated Ground",
    "regex": "신성",
    "engRegex": "nse",
    "lv": 5
  },
  {
    "no": 33,
    "mod": "몬스터가 명중 시 격분 충전 획득",
    "engMod": "Monsters gain a Frenzy Charge on Hit",
    "regex": "시.격",
    "engRegex": "zy c",
    "lv": 5
  },
  {
    "no": 34,
    "mod": "몬스터가 명중 시 인내 충전 획득",
    "engMod": "Monsters gain an Endurance Charge on Hit",
    "regex": "시.인",
    "engRegex": "n en",
    "lv": 5
  },
  {
    "no": 35,
    "mod": "몬스터가 명중 시 권능 충전 획득",
    "engMod": "Monsters gain a Power Charge on Hit",
    "regex": "시.권.*득",
    "engRegex": "a pow",
    "lv": 5
  },
  {
    "no": 36,
    "mod": "몬스터가 명중 시 실명 유발",
    "engMod": "Monsters Blind on Hit",
    "regex": "실명",
    "engRegex": "s bli",
    "lv": 5
  },
  {
    "no": 37,
    "mod": "몬스터가 공격 명중 시 힘줄 절단 유발",
    "engMod": "Monsters Maim on Hit with Attacks",
    "regex": "힘줄",
    "engRegex": "aim",
    "lv": 5
  },
  {
    "no": 38,
    "mod": "몬스터의 주문 명중 시 이동 방해 유발",
    "engMod": "Monsters Hinder on Hit with Spells",
    "regex": "해.유",
    "engRegex": "hind",
    "lv": 5
  },
  {
    "no": 40,
    "mod": "몬스터의 권능 충전 최대치 +1\n몬스터가 명중 시 권능 충전 획득",
    "engMod": "Monsters have +1 to Maximum Power Charges\nMonsters gain a Power Charge on Hit",
    "regex": "의.권",
    "engRegex": "mum po",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 41,
    "mod": "몬스터의 격분 충전 최대치 +1\n몬스터가 명중 시 격분 충전 획득",
    "engMod": "Monsters have +1 to Maximum Frenzy Charges\nMonsters gain a Frenzy Charge on Hit",
    "regex": "의.격",
    "engRegex": "mum f",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 42,
    "mod": "몬스터의 인내 충전 최대치 +1\n몬스터가 피격 시 인내 충전 획득",
    "engMod": "Monsters have +1 to Maximum Endurance Charges\nMonsters gain an Endurance Charge when hit",
    "regex": "의.인",
    "engRegex": "m end",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 43,
    "mod": "플레이어의 모든 저항 최대치 -20%",
    "engMod": "Players have -20% to all maximum Resistances",
    "regex": "항.최",
    "engRegex": "o al",
    "lv": 17
  },
  {
    "no": 44,
    "mod": "몬스터의 치명타 확률 (650-700)% 증가\n몬스터의 치명타 피해 배율 +(70-75)%",
    "engMod": "Monsters have (650-700)% increased Critical Strike Chance\n+(70-75)% to Monster Critical Strike Multiplier",
    "regex": "배율",
    "engRegex": "lier",
    "lv": 17
  },
  {
    "no": 45,
    "mod": "몬스터의 공격 명중 시 중독\n몬스터의 모든 명중 피해가 중독 유발 가능\n몬스터의 중독 지속시간 100% 증가",
    "engMod": "Monsters Poison on Hit\nAll Damage from Monsters' Hits can Poison\nMonsters have 100% increased Poison Duration",
    "regex": "독.지",
    "engRegex": "' h",
    "lv": 17
  },
  {
    "no": 47,
    "mod": "플레이어가 취약성 저주에 걸림\n플레이어가 시간의 사슬 저주에 걸림\n플레이어가 원소 약화 저주에 걸림",
    "engMod": "Players are Cursed with Vulnerability\nPlayers are Cursed with Temporal Chains\nPlayers are Cursed with Elemental Weakness",
    "regex": "취",
    "engRegex": "h vu",
    "lv": 17,
    "opt": "갑충 50%"
  },
  {
    "no": 48,
    "mod": "플레이어의 효과 범위 (25~30)% 감폭",
    "engMod": "Players have (25~30)% less Area of Effect",
    "regex": "플.*범",
    "engRegex": "ss are",
    "lv": 17
  },
  {
    "no": 49,
    "mod": "몬스터가 치명타로 받는 추가 피해 (35~45)% 감소",
    "engMod": "Monsters take (35~45)% reduced Extra Damage from Critical Strikes",
    "regex": "는.추",
    "engRegex": "kes",
    "lv": 17
  },
  {
    "no": 50,
    "mod": "고유 몬스터가 무작위 성소 버프 1개 보유",
    "engMod": "Unique Monsters have a random Shrine Buff",
    "regex": "소.버",
    "engRegex": "e a r",
    "lv": 17,
    "opt": "지도 50%"
  },
  {
    "no": 51,
    "mod": "지역에 석화의 조각상 등장",
    "engMod": "Area contains Petrification Statues",
    "regex": "조각",
    "engRegex": "pet",
    "lv": 17,
    "opt": "갑충 50%"
  },
  {
    "no": 54,
    "mod": "몬스터 기절 면역\n몬스터의 동작 속도가 기본 수치 밑으로 내려가지 않음\n몬스터의 이동 속도가 기본 수치 밑으로 내려가지 않음",
    "engMod": "Monsters cannot be Stunned\nMonsters' Action Speed cannot be modified to below Base Value\nMonsters' Movement Speed cannot be modified to below Base Value",
    "regex": "기절",
    "engRegex": "' mo",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 55,
    "mod": "플레이어가 플라스크 사용 시 유성의 대상이 됨",
    "engMod": "Players are targeted by a Meteor when they use a Flask",
    "regex": "유성",
    "engRegex": "teo",
    "lv": 17,
    "opt": "화폐 70%"
  },
  {
    "no": 56,
    "mod": "플레이어의 방어력 (25~30)% 감폭",
    "engMod": "Players have (25~30)% less Defences",
    "regex": "어력",
    "engRegex": "efe",
    "lv": 17,
    "opt": "갑충 50%"
  },
  {
    "no": 61,
    "mod": "플레이어에게 적용되는 버프가 100% 더 빠르게 만료됨",
    "engMod": "Buffs on Players expire 100% faster",
    "regex": "플.*빠",
    "engRegex": "n pl",
    "lv": 17,
    "opt": "갑충 50%"
  },
  {
    "no": 62,
    "mod": "몬스터 피해가 15%의 원소 저항 관통",
    "engMod": "Monster Damage Penetrates 15% Elemental Resistances",
    "regex": "관통",
    "engRegex": "net",
    "lv": 17
  },
  {
    "no": 63,
    "mod": "플레이어가 최근 4초 이내에 스킬을 사용한 횟수 1회당\n해당 플레이어의 동작 속도 3% 감소",
    "engMod": "Players have 3% reduced Action Speed for each time they've used a Skill Recently",
    "regex": "한.횟",
    "engRegex": "'v",
    "lv": 17
  },
  {
    "no": 64,
    "mod": "지역에 불안정한 촉수 마귀 등장",
    "engMod": "Area contains Unstable Tentacle Fiends",
    "regex": "촉수",
    "engRegex": "tab",
    "lv": 17
  },
  {
    "no": 65,
    "mod": "지역에 각성자의 비애 지대 존재",
    "engMod": "Area has patches of Awakeners' Desolation",
    "regex": "비애",
    "engRegex": "wak",
    "lv": 17
  },
  {
    "no": 67,
    "mod": "플레이어들의 소환수의 공격 속도 50% 감폭\n플레이어들의 소환수의 시전 속도 50% 감폭\n플레이어들의 소환수의 이동 속도 50% 감폭",
    "engMod": "Players' Minions have 50% less Attack Speed\nPlayers' Minions have 50% less Cast Speed\nPlayers' Minions have 50% less Movement Speed",
    "regex": "들의.소",
    "engRegex": "' mi",
    "lv": 17,
    "opt": "갑충 33%"
  },
  {
    "no": 68,
    "mod": "몬스터에게 적용되는 디버프가 100% 더 빠르게 만료됨",
    "engMod": "Debuffs on Monsters expire 100% faster",
    "regex": "몬.*디",
    "engRegex": "deb",
    "lv": 17,
    "opt": "화폐 109%"
  },
  {
    "no": 69,
    "mod": "메이븐이 플레이어를 방해함",
    "engMod": "The Maven interferes with Players",
    "regex": "메이",
    "engRegex": "mav",
    "lv": 17
  },
  {
    "no": 70,
    "mod": "흡수로 인한 플레이어의 초당 총 생명력, 마나, 에너지 보호막 회복량 최대치가 (50-60)% 감소",
    "engMod": "Players have 50-60% reduced Maximum total Life, Mana and Energy Shield Recovery per second from Leech",
    "regex": "의.초",
    "engRegex": "eec",
    "lv": 17
  },
  {
    "no": 71,
    "mod": "희귀 몬스터가 사망 시 25%의 확률로 분쇄됨", 
    "engMod": "25% chance for Rare Monsters to Fracture on death",
    "regex": "분쇄",
    "engRegex": "fra",
    "lv": 17
   }
]

export default mapMod;